import Translate from "Components/Translate";
import { CANCEL, NEW_PASSWORD, OLD_PASSWORD } from "Constant";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import React, { useState } from "react";
import axiosClient from "Services/axiosClient";
import sha512 from "js-sha512";

const ResetPassword = ({ onCancel, toastRef }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [strength, setStrength] = useState("faible");
  const [isLoading, setIsLoading] = useState(false);

  const handleOldPasswordChange = (e) => {
    const value = e.target.value;

    // Autoriser uniquement les entrées numériques et limiter à 6 caractères
    if (/^\d{0,6}$/.test(value)) {
      setOldPassword(value);
    }
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;

    // Autoriser uniquement les entrées numériques et limiter à 6 caractères
    if (/^\d{0,6}$/.test(value)) {
      setNewPassword(value);

      // Mettre à jour la force du mot de passe en fonction de la longueur
      setStrength(value.length === 6 ? "forte" : "faible");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const hashOldPass = sha512(oldPassword);
    const hashNewPass = sha512(newPassword);

    const postData = {
      oldPassword: hashOldPass,
      newPassword: hashNewPass,
    };

    axiosClient
      .patch("/front/reset-password", postData)
      .then((res) => {
        // Afficher la notification toast avec la référence passée
        toastRef.current.show({
          severity: "success",
          summary: "Réinitialisation réussie",
          detail: "Votre mot de passe a été mis à jour avec succès.",
          life: 10000,
        });

        setIsLoading(false);
        onCancel(); // Fermer le modal
      })
      .catch((err) => {
        console.error(err);
        toastRef.current.show({
          severity: "error",
          summary: "Erreur",
          detail:
            "Échec de la réinitialisation du mot de passe. Veuillez vérifier vos informations.",
        });
        setIsLoading(false);
      });
  };

  // console.log(!newPassword.length === 6);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        {/* Champ pour l'ancien mot de passe */}
        <div className="field" style={{ marginBottom: "20px" }}>
          <label htmlFor="old-password" style={{ fontWeight: "bold" }}>
            <Translate>{OLD_PASSWORD}</Translate>
          </label>
          <Password
            id="old-password"
            value={oldPassword}
            onChange={handleOldPasswordChange}
            placeholder="6 chiffres"
            toggleMask
            feedback={false}
          />
        </div>

        {/* Champ pour le nouveau mot de passe */}
        <div className="field" style={{ marginBottom: "20px" }}>
          <label htmlFor="new-password" style={{ fontWeight: "bold" }}>
            <Translate>{NEW_PASSWORD}</Translate>
          </label>
          <Password
            id="new-password"
            value={newPassword}
            onChange={handleNewPasswordChange}
            style={{
              width: "100%",
              borderColor: strength === "forte" ? "green" : "red",
            }}
            placeholder="6 chiffres"
            toggleMask
            feedback={false}
          />
          <div
            style={{
              height: "5px",
              backgroundColor: strength === "forte" ? "green" : "red",
              marginTop: "5px",
              borderRadius: "2px",
              width: `${(newPassword.length / 6) * 100}%`,
              transition: "width 0.3s ease",
            }}
          />
          {newPassword.length === 6 ? null : (
            <small style={{ color: "red", fontSize: "0.85rem" }}>
              Le mot de passe doit contenir exactement 6 chiffres.
            </small>
          )}
        </div>

        {/* Boutons d'action */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <Button
            onClick={onCancel}
            severity="secondary"
            type="button"
            label={<Translate>{CANCEL}</Translate>}
          />
          <Button
            type="submit"
            label="Envoyer"
            severity="success"
            loading={isLoading}
            disabled={newPassword.length < 6}
          />
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
